import React from 'react';

type props = {
  label: string;
  numericValue: string;
  header?: string;
  pending?: boolean;
  subHeader?: string;
};

const NumberLabel: React.FunctionComponent<props> = ({
  numericValue,
  label,
  header,
  subHeader,
  pending,
}): JSX.Element => {
  return (
    <div className="relative mx-2">
      <div className="text-gray-dark text-base font-bold">{header}</div>
      <div className="font-montseerat text-gray-dark text-base font-normal">{subHeader}</div>
      <div className="blue-primary font-montseerat mt-2 text-4xl font-normal">{!pending ? numericValue : 0}</div>
      <div className="font-montseerat text-gray-dark text-base font-normal">{label}</div>
    </div>
  );
};

export default NumberLabel;
